import { combineReducers } from 'redux';

import landingReducer from 'components/landing/slice';
import toolbarReducer from "components/editor/Toolbar/slice";
import documentReducer from "components/editor/Document/slice";
import headingsReducer from "nodes/Heading/slice";
import footnotesReducer from "nodes/FootNote/slice";
import cursorReducer from "_utils/slices/cursorSlice";
import authReducer from '_utils/slices/authSlice';
import documentsReducer from 'components/main/Documents/slice';
import exportModalReducer from 'components/editor/ExportModal/slice';
import shareModalReducer from 'components/editor/ShareModal/slice';
import spellcheckerReducer from 'components/editor/Sidebar/SpellChecker/slice'
import { authApi } from '_services/auth';
import { documentsApi } from '_services/documents';
import { userApi } from '_services/user';
import { refApi } from '_services/ref';
import { myRefGroupsApi } from '_services/myrefgroups';
import { myRefApi } from '_services/myref';
import { spellcheckerApi } from '_services/spellchecker';
import { snapshotApi } from '_services/snapshot';


export default combineReducers({
    toolbar: toolbarReducer,
    document: documentReducer,
    cursor: cursorReducer,
    headings: headingsReducer,
    footnotes: footnotesReducer,
    auth: authReducer,
    landing: landingReducer,
    documents: documentsReducer,
    exportModal: exportModalReducer,
    shareModal: shareModalReducer,
    spellchecker: spellcheckerReducer,

    [authApi.reducerPath]: authApi.reducer,
    [documentsApi.reducerPath]: documentsApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [refApi.reducerPath]: refApi.reducer,
    [myRefGroupsApi.reducerPath]: myRefGroupsApi.reducer,
    [myRefApi.reducerPath]: myRefApi.reducer,
    [spellcheckerApi.reducerPath]: spellcheckerApi.reducer,
    [snapshotApi.reducerPath]: snapshotApi.reducer,


});